import { Card, Fade, Icon, Modal, Slide } from "@mui/material"
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import DataTable from "components/Tables/DataTable";
import dataIngredientes from "../data/dataIngredientes";
import { useEffect, useState } from "react";
import { getUproColor } from "utils/colors";

function ModalVerReceta({ open, title, onClose, ingredientesList, loadingList }) {

    const { columns2, getRows } = dataIngredientes;
    const [rows, setRows] = useState([]);

    useEffect(() => setRows(getRows(ingredientesList)), [ingredientesList, getRows])

    return (
        <Modal
            open={open}
            onClose={onClose}
            sx={{ width: "100%" }}
            closeAfterTransition
        >
            <Fade in={open}>
                <Card sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 'auto',
                    minWidth: "45%",
                    minHeight: "60%",
                    overflow: "auto",
                    maxHeight: "70vh",
                    p: 3.5,
                }}>
                    <Slide in={loadingList} direction="up" mountOnEnter unmountOnExit>
                        <SoftBox
                            bgColor={getUproColor("uproGray")}
                            p={3}
                            py={"5rem"}
                            display="flex"
                            flexDirection="column"
                            justifyContent="center"
                            alignItems="center"
                            textAlign="center"
                            sx={{
                                width: "100%",
                                height: "100%",
                                minHeight: "100%",
                                minWidth: "100%",
                                position: "absolute",
                                top: 0,
                                left: 0,
                            }}
                        >
                            <Icon
                                fontSize="large"
                                sx={{
                                    color: "#fff",
                                    animation: "shakes 1s infinite",
                                    "@keyframes shakes": {
                                        "0%": {
                                            transform: "rotate(0deg)",
                                        },
                                        "25%": {
                                            transform: "rotate(10deg)",
                                        },
                                        "50%": {
                                            transform: "rotate(-20deg)",
                                        },
                                        "75%": {
                                            transform: "rotate(15deg)",
                                        },
                                        "100%": {
                                            transform: "rotate(-5deg)",
                                        },
                                    },
                                }}
                            >
                                hourglass_empty
                            </Icon>
                            <SoftTypography variant="h5" color="white" fontWeight="bold" mt={2}>
                                Cargando datos
                            </SoftTypography>
                        </SoftBox>
                    </Slide>
                    {!loadingList && (<> <SoftBox display="flex" gap={1} alignItems="center" justifyContent={"space-between"} mb={4}>
                        <SoftBox display="flex" gap={1} alignItems="center" justifyContent={"space-between"}>
                            <Icon fontSize="medium" color="warning">restaurant</Icon>
                            <SoftTypography variant="h7" fontWeight="regular">
                                Receta:{" "}
                                <SoftTypography component="span" variant="h7" fontWeight="bold" color="error">
                                    {title}
                                </SoftTypography>
                            </SoftTypography>
                        </SoftBox>
                        <SoftBox display="flex" gap={1} alignItems="center" sx={{ cursor: "pointer" }} onClick={onClose}>
                            <Icon fontSize="medium" color="dark">close</Icon>
                        </SoftBox>
                    </SoftBox>
                        <SoftBox mb={2}>
                            <DataTable
                                columns={columns2}
                                rows={rows}
                            />
                        </SoftBox>
                        <SoftBox display="flex" flexDirection="column" gap={2} mt={2}>
                            <SoftButton
                                variant="gradient"
                                color="secondary"
                                onClick={onClose}
                                circular
                                fullWidth
                            >
                                <Icon>undo</Icon>&nbsp;Volver
                            </SoftButton>
                        </SoftBox></>)}
                </Card>
            </Fade>
        </Modal>
    )
}

export default ModalVerReceta